import { createFileRoute } from '@tanstack/react-router';

type ProductSearchParams = {
  tab?: string;
  q?: string;
  page?: number;
  brand?: string;
  collection?: string;
  priceMin?: string;
  priceMax?: string;
};

export const Route = createFileRoute('/products/')({
  validateSearch: (search: Record<string, unknown>): ProductSearchParams => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    brand: typeof search.brand === 'string' ? search.brand : undefined,
    collection: typeof search.collection === 'string' ? search.collection : undefined,
    priceMin: typeof search.priceMin === 'string' ? search.priceMin : undefined,
    priceMax: typeof search.priceMax === 'string' ? search.priceMax : undefined,
  }),
});
